import { render, staticRenderFns } from "./FluterDiscountBanner.vue?vue&type=template&id=22833114&scoped=true&"
import script from "./FluterDiscountBanner.vue?vue&type=script&lang=js&"
export * from "./FluterDiscountBanner.vue?vue&type=script&lang=js&"
import style0 from "./FluterDiscountBanner.vue?vue&type=style&index=0&id=22833114&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22833114",
  null
  
)

export default component.exports